import React, { useCallback, useEffect, useState } from 'react';
import { Input } from 'antd';
import { ArrowLeftIcon, SearchNormalIcon } from 'icons';
import debounce from 'lodash.debounce';
import { useTranslations } from 'next-intl';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

import { SubjectsDrawer, SubjectsList } from 'components';

interface IProps {
  children: React.ReactNode;
}

const TopicTestLayout: React.FC<IProps> = ({ children }) => {
  const t = useTranslations();
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useQueryParams({
    search: withDefault(StringParam, ''),
    page: withDefault(StringParam, '1')
  });

  const [tempValue, setTempValue] = useState<string>(query?.search);

  useEffect(() => {
    setTempValue(query?.search);
  }, [query?.search]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSearch = useCallback(
    debounce((val: string) => {
      setQuery({
        search: val || undefined,
        page: undefined
      });
    }, 300),
    []
  );

  return (
    <div className="mx-auto mt-4 min-h-screen max-w-screen px-4 lg:mt-10">
      <h1 className="mb-3 hidden text-2xl font-bold lg:block">{t('bilimingizni_sinovdan_otkazadigan_joy')}</h1>

      <div className="flex items-center justify-between lg:hidden">
        {!searchOpen ? (
          <>
            <h2 className="text-xl font-bold">{t('nav.mavzuli_test')}</h2>
            <div className="flex items-center gap-2">
              <SubjectsDrawer />
              <div className="rounded-xl px-3 min-h-10 flex items-center justify-center bg-white border border-gray-300" onClick={() => setSearchOpen(true)}>
                <SearchNormalIcon />
              </div>
            </div>
          </>
        ) : (
          <div className="flex w-full items-center gap-2">
            <div
              className="cursor-pointer"
              onClick={() => {
                setSearchOpen(false);
                setTempValue('');
                setQuery({
                  search: undefined
                });
              }}
            >
              <ArrowLeftIcon />
            </div>
            <Input
              value={tempValue}
              autoFocus
              placeholder={t('Qidiruv')}
              className="!h-[2.6rem] !rounded-xl !bg-white"
              size="small"
              onClear={() => {
                setTempValue('');
                setQuery({
                  search: undefined
                });
              }}
              onChange={e => {
                const val = e.target.value;

                setTempValue(val);
                debouncedSetSearch(val);
              }}
            />
          </div>
        )}
      </div>

      <div className="mt-5 grid grid-cols-1 gap-4 lg:grid-cols-4">
        <div className="hidden self-start md:sticky md:top-4 lg:block">
          <SubjectsList />
        </div>

        <div className="sm:col-span-3">{children}</div>
      </div>
    </div>
  );
};

export default TopicTestLayout;
